import React from 'react';
import { string } from 'prop-types';

const IconPackage = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 18H16V16H7V18Z" fill="black" />
      <path d="M13 22H7V20H13V22Z" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 5H2V27H30V5ZM4 25V7H12.5V11L19.5 11V7H28V25H4Z"
        fill="black"
      />
    </svg>
  );
};

IconPackage.defaultProps = { className: null };

IconPackage.propTypes = {
  className: string,
};

export default IconPackage;
